import { base64URLEncode } from '../utils/string';
export const generateNonce = () => {
    const randomArray = new Uint8Array(32);
    crypto.getRandomValues(randomArray);
    const nonce = String.fromCharCode(...randomArray);
    return base64URLEncode(nonce);
};
